<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				售卡列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{total}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<div style="padding: 15px 25px;display: flex;align-items: center;" class="search">
				<el-select v-model="form.software_choosed" clearable placeholder="请选择所属软件"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(item,index) in software_list" :key="index" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="form.pay_method_choosed" clearable placeholder="请选择支付方式"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(item,index) in pay_method_chooseds" :key="index" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-select v-model="form.status_choosed" clearable placeholder="请选择订单状态"
					style="width: 150px;margin-right: 10px;" @change="search" size="small">
					<el-option v-for="(item,index) in status" :key="index" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-input clearable placeholder="请输入订单号" v-model="form.order_no" size="small"
					style="width: 250px;margin-right: 20px;">
					<el-button slot="append" type="primary" icon="el-icon-search" @click="search"></el-button>
				</el-input>
			</div>
			<div style="padding: 0px 20px 0px 20px;">
				<el-table ref="tablelist" :data="list" stripe
					style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;"
					size="small" :header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
					:row-style="{border_color:'rgb(75, 83, 87)'}" height="600" v-loading="loading">
					
					<el-table-column label="订单号" align="center" min-width="250" show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.out_trade_no}}
						</template>
					</el-table-column>
					<el-table-column label="卡密内容" width="200" align="center" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.content.length==0">{{scope.row.content[0]}}</span>
							<span v-else style="cursor: pointer;" @click="showMore(scope.row.content)">点击查看</span>
						</template>
					</el-table-column>
					<el-table-column label="数量" align="center" width="60">
						<template slot-scope="scope">
							{{scope.row.num}}
						</template>
					</el-table-column>
					<el-table-column label="软件" width="150" align="center">
						<template slot-scope="scope">
							{{software_info[scope.row.software] ? software_info[scope.row.software].name : '已删除'}}
						</template>
					</el-table-column>
					<el-table-column label="支付方式" width="150" align="center">
						<template slot-scope="scope">
							{{scope.row.method==='ali'?'支付宝':'其他方式'}}
						</template>
					</el-table-column>
					
					<el-table-column label="支付金额(元)" width="100" align="center">
						<template slot-scope="scope">
							{{(scope.row.total_fee/100).toFixed(2)}}
						</template>
					</el-table-column>
					<el-table-column label="类型" width="90" align="center">
						<template slot-scope="scope">
							{{scope.row.msg}}
						</template>
					</el-table-column>
					
					<el-table-column label="代理人ID" width="90" align="center">
						<template slot-scope="scope">
							{{scope.row.agent_id||'-'}}
						</template>
					</el-table-column>
					<el-table-column label="代理人收款" width="120" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.agent_id">
								{{(scope.row.agent_getmoney + scope.row.uper_agent_getmoney)/100}}
							</span>
							<span v-else>-</span>
						</template>
					</el-table-column>
					<el-table-column label="支付时间" width="170" align="center">
						<template slot-scope="scope">
							{{scope.row.time_date}}
						</template>
					</el-table-column>
					<el-table-column label="订单状态" width="200" align="center">
						<template slot-scope="scope">
							{{scope.row.status==0?'未结算':'已结算'}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="footer" style="margin-top: 15px;">
				<el-pagination layout="total, prev, pager, next" @current-change="toPage" :total="total"
					:page-sizes="[10,50,100,500,1000]" :current-page="form.page" :page-size="limit">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="卡密内容" :visible.sync="dialogVisible" width="300px">
			<div style="max-height: 400px;overflow-y: auto;">
				<div style="font-size:14px;color:#aaa;margin-bottom: 5px;" v-for="(item,index) in content" :key="index">
					{{item}}
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let timer = null;
	import {mapState} from 'vuex'
	export default {
		
		data() {
			return {
				dialogVisible:false,
				content:[],
				cards: '',
				loading: false,
				days: 0,
				limit: 15,
				total: 0,
				form: {
					page: 1,
					order_no: '',
					software_choosed: '',
					pay_method_choosed: '',
					status_choosed: '',
					agent_id: '',
				},
				software_info: {},
				now_timestamp: 0,
				list: [],
				software_list: [],
				pay_method_chooseds: [{
					label: '支付宝',
					value: 'ali'
				}, {
					label: '微信支付',
					value: 'wechat'
				}],
				status: [{
					label: '已结算',
					value: '1'
				}, {
					label: '未结算',
					value: '0'
				}]
			}
		},
		filters: {
			formatTime(value) {
				if (value == 0) return ''
				let date = new Date(value * 1000)
				var year = date.getFullYear();
				var month = ("0" + (date.getMonth() + 1)).slice(-2);
				var sdate = ("0" + date.getDate()).slice(-2);
				var hour = ("0" + date.getHours()).slice(-2);
				var minute = ("0" + date.getMinutes()).slice(-2);
				var second = ("0" + date.getSeconds()).slice(-2);
				// 拼接
				var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
				// 返回
				return result;
			}
		},
		computed: {
			...mapState({
				user: state => state.user,
				reload:state=>state.reload
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		created() {
			this.getData()
			this.getSoftwareList()
		},
		mounted() {
			this.$nextTick(() => {
				console.log(this.$refs.tablelist.bodyWidth)
				this.$refs.tablelist.bodyWrapper.scrollLeft = 0
				let scrollLeft = 1
				let type = 'add'
				timer = setInterval(()=>{
					if(type=='add'){
						scrollLeft = scrollLeft+20
					}else{
						scrollLeft = scrollLeft-20
					}
					
					this.$refs.tablelist.bodyWrapper.scrollLeft = scrollLeft
					if((scrollLeft-1)>this.$refs.tablelist.bodyWrapper.scrollLeft){
						type="sub"
					}
					if(scrollLeft<=0){
						clearInterval(timer)
						this.$refs.tablelist.bodyWrapper.scrollLeft = 0
					}
					this.scrollLeft = this.$refs.tablelist.bodyWrapper.scrollLeft
				},30)
			})
		},
		methods: {
			showMore(content){
				this.content = content
				this.dialogVisible = true
			},
			getSoftwareList() {
				this.$H.post('verify_center/v1_0_1.Software/list').then(res => {
					if (res.data) {
						this.software_list = res.data.list;
					}

				});
			},
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_1.Amount/CardSellLog', this.form).then(res => {
					this.loading = false
					if (res.data) {
						if (this.form.page === 1) {
							this.total = res.data.list.total
							this.software_info = res.data.software_info;
						}
						console.log(res.data)
						this.list = res.data.list.data.map(item=>{
							item.content = JSON.parse(item.content)
							return item
						})

					}
				}).catch(err => {
					this.loading = false
				})
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>